import axios from "axios";
import { useEffect, useState } from "react";
import { API_CONFIG, API_HEADERS } from "./Api/API_CONFIG";
import Carousel from "react-bootstrap/Carousel";
import About from "./AboutUS";
import ReferAndSave from "./refer-save";
// import AppNotification from "./notification";

function Slider() {
  const [result, setResult] = useState([]);
  useEffect(() => {
    fetchImages();
    // AppNotification();
  }, []);
  const fetchImages = async () => {
    let data = await axios.get(API_CONFIG.API_HOST + "Banner/list?type=HOME", {
      headers: API_HEADERS,
    });
    console.log(data.data.result);
    setResult(data.data.result);
  };
  return (
    <>
      <div>
        <Carousel fade className="carousel-image w-100">
          {result &&
            result.length > 0 &&
            result.map((item) => {
              let path = `https://swara.biyss.com/${item.image_path}`;
              console.log("item", path);
              return (
                <Carousel.Item className="w-100">
                  <img
                    className="w-100 image-height"
                    src={path}
                    alt="First slide"
                  />
                </Carousel.Item>
              );
            })}
        </Carousel>
      </div>
    </>
  );
}
export default Slider;
